import { useMutation, useQuery } from "@tanstack/react-query";
import {
  APIErrorResponse,
  ICreatedBy,
  IListResponseMeta,
} from "src/types/generic";
import apiClient from "../apiClient";

interface ICatBody {
  id?: number;
  name: string;
}

interface ICatRes {
  id: number;
  name: string;
  created_at: string;
  created_by: ICreatedBy;
}

export const useGetAssetCategories = (params?: { page?: number }) =>
  useQuery<any, APIErrorResponse, { data: ICatRes[]; meta: IListResponseMeta }>(
    {
      queryKey: ["get-asset-categories", params?.page],
      queryFn: async () => {
        return apiClient.get(`/api/categories`, { params: params || {} });
      },
    },
  );

export const useAddAssetCategoryMutation = () =>
  useMutation<void, APIErrorResponse, ICatBody>({
    mutationFn: async (data) => {
      return apiClient.post(`/api/categories`, data);
    },
  });

export const useUpdateAssetCategoryMutation = () =>
  useMutation<void, APIErrorResponse, ICatBody>({
    mutationFn: async (data) => {
      const { id, ...rest } = data;
      return apiClient.put(`/api/categories/${id}`, rest);
    },
  });

export const useDeleteAssetCategoryMutation = () =>
  useMutation<void, APIErrorResponse, number>({
    mutationFn: async (id) => {
      return apiClient.delete(`/api/categories/${id}`);
    },
  });
